import {Component, EventEmitter, Input, OnChanges, OnInit, Output,} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {first, map} from 'rxjs/operators';
import {DynamicFormService} from '../dynamic-form.service';
import {FieldConfig, FieldType} from '../field.interface';
import {SettingsService} from '../../../../services/settings.service';

@Component({
    exportAs: 'dynamicForm',
    selector: 'main-dynamic-form',
    template: `
    @if (loading) {
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    }
    @if (loading) {
      <p>{{ loadingMessage }}</p>
    }
    
    <form
      class="dynamic-form"
      [formGroup]="form"
      (submit)="onSubmit($event)"
      autocomplete="off"
      >
      <div class="row">
        @for (field of fields; track field) {
          @if (isVisible(field)) {
            <div
            [ngClass]="{
              'col-md-6': field.rowClass === 'medium' || !field.rowClass,
              'col-md-3': field.rowClass === 'small',
              'col-md-12': field.rowClass === 'large'
            }"
              >
              <ng-container
                appDynamicField
                [field]="field"
                [group]="form"
                (cancelForm)="cancelForm()"
                (selectedValue)="selectedValue($event)"
              ></ng-container>
            </div>
          }
        }
      </div>
    </form>
    `,
    // animations: [fadeIn],
    styles: [],
    standalone: false
})
export class MainDynamicFormComponent implements OnInit, OnChanges {
  @Input() fields: FieldConfig[] = [];
  @Input() formData: any = null;
  @Input() isFormOpen = true;
  @Input() loading = false;
  @Input() loadingMessage = 'Please Wait, Loading Form Options...';
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeForm: EventEmitter<any> = new EventEmitter<any>();
  @Input() form: UntypedFormGroup;

  selectedKeyValue = [];
  get value() {
    return this.form.value;
  }
  constructor(
    private settings: SettingsService,
    private dynamicFormService: DynamicFormService
  ) {}

  ngOnInit() {
    // tslint:disable-next-line:max-line-length
    // this.form = this.form && Object.keys(this.form.controls).length > 0 ? this.form : this.dynamicFormService.createControl(this.fields, this.formData);
    if (!this.isFormOpen) {
      this.form.reset();
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  cancelForm() {
    this.closeForm.emit();
  }

  isVisible(field: FieldConfig, option = null): boolean {
    const visible = this.dynamicFormService.isVisible(field, this.form, option);
    if (field.visible === false) {
      return false;
    }
    if (field.type !== FieldType.button) {
      if (!visible) {
        this.form.controls[field.key].setValidators(null);
      } else {
        if (field.type === FieldType.dateRange) {
          this.form.controls[field.dateRangeFirstKey].setValidators(
            this.dynamicFormService.bindValidations(field.validations || [])
          );

          this.form.controls[field.dateRangeLastKey].setValidators(
            this.dynamicFormService.bindValidations(field.validations || [])
          );
        }
        this.form.controls[field.key].setValidators(
          this.dynamicFormService.bindValidations(field.validations || [])
        );
      }
      if (field.type === FieldType.dateRange) {
        this.form.controls[field.dateRangeFirstKey].updateValueAndValidity();
        this.form.controls[field.dateRangeLastKey].updateValueAndValidity();
      }
      this.form.controls[field.key].updateValueAndValidity();
    }
    return visible;
  }

  async selectedValue(data: {
    value: string;
    field: FieldConfig;
    object: any;
  }) {
    this.selectedData.emit({
      value: data.value,
      key: data.field.key,
      object: data.object,
    });
    const dataField = this.fields.find(
      (f) => f.filterValueKey === data.field.key
    );
    // tslint:disable-next-line:max-line-length
    const option = data.field.useObservable
      ? await data.field.options
          .pipe(
            map((items: any[]) =>
              items ? items.find((opt) => opt.value === data.value) : null
            ),
            first()
          )
          .toPromise()
      : data.field.options?.find((opt) => opt.value === data.value); // TODO: add Null checking
    this.isVisible(data.field, option);
    if (dataField) {
      this.fields = this.fields.map((field) => {
        return {
          ...field,
        };
      });
    }
  }

  onSubmit(event: Event) {
    this.submit.emit(
      this.dynamicFormService.onSubmit(event, this.form, this.fields)
    );
  }
}
